import { HeaderMenu } from "components";
import { Filter } from "./components";
import { useList, useShift } from "./hooks";
import { FormProvider, useForm } from "react-hook-form";
import { FormType } from "./schemas";
import { useCode } from "./hooks/useCode"
import { ContentSection } from "./components/Action/ContentSection";
import { useFilterStore } from "./stores";
import { useShiftScheduleForm } from "./functions";
import { useEffect } from "react";

export default function CreateShiftSchedule() {

    // state
    const { filter, resetFilter } = useFilterStore();

    useEffect(() => {
        resetFilter();

        // eslint-disable-next-line
    }, []);

    // hooks
    const { data, isLoading, refetch } = useList(filter);
    const { data: code, refetch: refetchCode } = useCode(filter.date_start)
    const { data: shift } = useShift();
    

    // useform
    const method = useForm<FormType>({
        defaultValues: {
            code: "",
            detail: []
        }
    });

    useShiftScheduleForm({
        data: data ?? [],
        code,
        method,
        shift
    });


    return (
        <FormProvider {...method}>
            <section className="container my-2">
                <HeaderMenu title="DATA ENTRY | CREATE SHIFT SCHEDULE" className="sticky top-[32px] z-[1]" />

                <div className="sticky top-[100px] py-4 z-[2] bg-white dark:bg-black">
                    <Filter />
                </div>

                <ContentSection
                    data={data ?? []}
                    isLoading={isLoading}
                    method={method}
                    refecth={refetch}
                    refecthCode={refetchCode}
                />
            </section>
        </FormProvider>
    )
}